module.exports = __webpack_public_path__ + "static/media/hearts_J.420971b1.png";